export default {
    0: {
        text: 'Active',
        type: 'success',
        id: 0
    },
    1: {
        text: 'Inactive',
        type: 'danger',
        id: 1
    }
};
